<template>
  <div class="not-found">
    <div class="not-found__inner">
      <img
          class="not-found__logo"
          src="/images/gardens/Ogrod_Swiatel_logo_vector_1line_white.svg"
          alt="Ogród Świateł logo" />
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">{{ $t('404.pageNotFound') }}</h1>
      <p class="not-found__text">{{ $t('404.pageNotFoundExplain') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    document.title = this.$t('404.pageNotFound');
  },
};
</script>

<style scoped>
/* paleta i typografia jak na landingach wystaw */
.not-found {
  min-height: 100vh;
  background-color: #090618;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  font-family: 'Poppins', sans-serif;
}

.not-found__inner {
  max-width: 620px;
  text-align: center;
}

.not-found__logo {
  width: 260px;
  max-width: 70%;
  height: auto;
  margin-bottom: 56px;
}

.not-found__code {
  font-size: 96px;
  line-height: 1;
  font-weight: 700;
  color: #e4e08b;
  margin: 0 0 16px;
  letter-spacing: 2px;
}

.not-found__title {
  font-size: 30px;
  font-weight: 600;
  color: #fbfbfc;
  margin: 0 0 14px;
}

.not-found__text {
  font-size: 17px;
  line-height: 1.6;
  color: rgba(251, 251, 252, 0.7);
  margin: 0;
}

@media only screen and (max-width: 600px) {
  .not-found__logo { margin-bottom: 36px; }
  .not-found__code { font-size: 68px; }
  .not-found__title { font-size: 23px; }
  .not-found__text { font-size: 15px; }
}
</style>
